export class PagestampState {
  public static readonly FIRST = 1;
  public static readonly LAST = 3;
  public static readonly OTHER = 5;
}
